export const faqs = [
  {
    question: 'Are hackathon entries unlimited?',
    answer:
      'No. Infinite aims to give all participants every comfort needed while they are hacking. This includes sufficient guidance from experienced mentors and organizers. For that reason the hackathon is limited to 100 individual hackers.',
  },
  {
    question: 'How are entrants chosen?',
    answer:
      'Applications are processed on a “first received, first processed” basis. If an applicant is qualified, their application is approved and they will be entered into the hackathon.',
  },
  {
    question: 'When will I find out if I have been accepted or not?',
    answer:
      'Application processing should take between 1-3 weeks depending on the volume received. All applicants will be notified once their application has been processed, whether they have been accepted, waitlisted or rejected.',
  },
  {
    question: 'Will there be a wait list?',
    answer:
      'Yes, there will be a wait list. All applicants will be notified once their application has been processed, whether they have been accepted, waitlisted or rejected.',
  },
  {
    question: 'Can I appeal the decision made by the organizers?',
    answer:
      "You will not have the opportunity to appeal the decision. Infinite aims to admit the hackers that we consider would take the most from the event. You do not need to be a super developer to be admitted. You can be a junior developer with a huge desire to learn and have fun or a senior developer able to hack a complex technical idea. If your application expresses that you want to learn, hack and have fun we will do our best to accept your application. This is the criteria on which an applicant's submission to hack is processed. Infinite does not and shall not discriminate on the basis of race, color, religion (creed), gender, gender expression, age, national origin (ancestry), disability, marital status, sexual orientation, or military status, in any of its activities or operations. These activities include, but are not limited to, the processing of the applicant's entry. Infinite is committed to providing an inclusive and welcoming environment for all members of our staff, clients, volunteers, subcontractors, vendors, and clients.",
  },
  {
    question: 'Will you be handing out Swag?',
    answer:
      'That is a very big YES! There will also be NFTs and POAPs handed out.',
  },
]

export const organizers = [
  {
    logo: 'dxdao.png',
    name: 'DXDAO',
    nameWithoutMayus: 'DXdao',
    rol: 'INFINITE INITIATOR',
    description: 'DECENTRALIZATION SUPER SOLDIER',
    url: 'https://dxdao.eth.limo/',
    isOrganizer: true,
  },
  {
    logo: 'hopr.png',
    name: 'HOPR',
    nameWithoutMayus: 'Hopr',
    rol: 'GENESIS CO-ORGANIZER',
    description: 'PRIVACY PIONEERS',
    url: 'https://hoprnet.org/',
    isOrganizer: true,
  },
  {
    logo: 'brink.png',
    name: 'BRINK',
    nameWithoutMayus: 'Brink',
    rol: 'GENESIS CO-ORGANIZER',
    description: 'AUTOMATION AFICIONADOS',
    url: 'https://brink.trade/',
    isOrganizer: true,
  },
  {
    logo: 'kleros.png',
    name: 'KLEROS',
    nameWithoutMayus: 'Kleros',
    rol: 'GENESIS CO-ORGANIZER',
    description: 'JUSTICE ARBITRATORS',
    url: 'https://kleros.io/',
    isOrganizer: true,
  },
  {
    logo: 'ethswarm.png',
    name: 'SWARM',
    nameWithoutMayus: 'Swarm',
    rol: 'GENESIS CO-ORGANIZER',
    description: 'DATA STORAGE CHAMPIONS',
    url: 'https://www.ethswarm.org/',
    isOrganizer: true,
  },
  {
    logo: 'join.png',
    name: 'JOIN US',
    rol: 'BECOME AN ORGANIZER',
    url: 'https://twitter.com/messages/compose?recipient_id=1544019424382009345',
    isOrganizer: false,
  },
]

export const infinitePhrases = [
  {
    text: 'INFINITE is by hackers for hackers',
  },
  {
    text: 'INFINITE is for hackers and builders',
  },
  {
    text: 'INFINITE is decentralized',
  },
  {
    text: 'INFINITE reimagines traditional hackathons',
  },
  {
    text: 'INFINITE is a unique "hacker-first" event',
  },
  {
    text: 'INFINITE ascended beyond the need of sponsors borders or dependencies',
  },
]
